var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:[_vm.type, _vm.size, { disabled: _vm.disabled, active: _vm.active }],on:{"click":_vm.onClick}},[_c('div',{staticClass:"button-content"},[(_vm.$slots.default)?_c('div',{staticClass:"icon"},[_vm._t("default")],2):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }